<!-- 员工服务预约表 -->
<template>
    <div>
    	<van-nav-bar
		  	title="员工服务预约表"
			left-arrow
		  	@click-left="$router.push('/')">
		</van-nav-bar>
		<Calendar
		    @choseDay="clickDay"
		    @changeMonth="changeDate"	 
		    @isToday="clickToday"    
		    :markDate=arr
	    ></Calendar>
	    <van-cell title='日期' label="2020/1/8" is-link to='/Detail'></van-cell>
		<van-cell title='日期' label="XXXX" is-link to='/Detail'></van-cell>
    </div>
</template>
<script>
	import Calendar from 'vue-calendar-component';
  	export default {
  		components: {
		    Calendar
		 },
   		data(){
   			return{
  				arr:['2020/1/4','2020/1/9','2020/1/29']
   			}
   		},
   		methods:{
   			clickDay(data) {
		      	console.log(data); //选中的日期
		      	console.log("点击的日期"+data);
		    },
		    changeDate(data) {
		      	console.log(data); //左右点击切换月份 切换
		    },
		    clickToday(data) {
		      	console.log(data); //跳到了本月
		    },


   		}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .wh_content_all{
		background-color: #fff
	}
	/deep/ .wh_content_item,/deep/ .wh_top_changge li{
		color: #000;
	}
	/deep/ .wh_jiantou2{
		border-top: 2px solid #000;
    	border-right: 2px solid #000;
	}
	/deep/ .wh_jiantou1{
		border-top: 2px solid #000;
    	border-left: 2px solid #000;
	}
	/deep/ .wh_container{
		border-bottom: 1px solid #eee;
	}
	.van-cell__title{
		font-size: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/Service/StaffBookForm.vue